<form #confirmForm="ngForm" class="sm:w-5/6">
  <div id="confirm-info-container" class="grid grid-cols-1">
    <div class="justify-self-start">
      <div class="text-xl font-denim-semibold">CONFIRM YOUR INFORMATION</div>
    </div>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!isLoading" class="grid grid-cols-1">
      <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
        <mat-form-field color="primary" class="my-2">
          <mat-label>First Name</mat-label>
          <input matInput type="text" name="FirstName" id="FirstName" [(ngModel)]="model.FirstName"
            #FirstName="ngModel">
        </mat-form-field>

        <mat-form-field color="primary" class="my-2">
          <mat-label>Last Name</mat-label>
          <input matInput type="text" name="LastName" id="LastName" [(ngModel)]="model.LastName"
            #LastName="ngModel">
        </mat-form-field>
      </div>

      <mat-form-field color="primary" class="my-2">
        <mat-label>Street</mat-label>
        <input matInput type="text" name="Address" id="Address" [(ngModel)]="model.Address" #Address="ngModel">
      </mat-form-field>

      <mat-form-field color="primary" class="my-2">
        <mat-label>City</mat-label>
        <input matInput type="text" name="City" id="City"  [(ngModel)]="model.City" #City="ngModel">
      </mat-form-field>

      <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
        <mat-form-field class="my-2">
          <mat-label>State</mat-label>
          <input matInput type="text" name="State" id="State" [(ngModel)]="model.State" #State="ngModel">
        </mat-form-field>

        <mat-form-field color="primary" class="my-2">
          <mat-label>Zip Code</mat-label>
          <input matInput type="text" name="Zip" id="Zip" [(ngModel)]="model.Zip" #Zip="ngModel">
        </mat-form-field>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
        <mat-form-field class="my-2">
          <mat-label>Date of Birth</mat-label>
          <input matInput [matDatepicker]="dbPicker" name="DateOfBirth" id="LicenseExDateOfBirthiration" readonly
            [(ngModel)]="model.DateOfBirth" #DateOfBirth="ngModel">
          <mat-datepicker-toggle matSuffix disabled [for]="dbPicker"></mat-datepicker-toggle>
          <mat-datepicker #dbPicker></mat-datepicker>
        </mat-form-field>
        <div></div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
        <mat-form-field color="primary" class="my-2">
          <mat-label>Identification Number</mat-label>
          <input matInput type="text" name="LicenseNumber" id="LicenseNumber" readonly [(ngModel)]="model.LicenseNumber"
            #LicenseNumber="ngModel">
        </mat-form-field>

        <mat-form-field class="my-2">
          <mat-label>Expiration Date</mat-label>
          <input matInput [matDatepicker]="lePicker" name="LicenseExpiration" id="LicenseExpiration" readonly
            [(ngModel)]="model.LicenseExpiration" #LicenseExpiration="ngModel">
          <mat-datepicker-toggle matSuffix disabled [for]="lePicker"></mat-datepicker-toggle>
          <mat-datepicker #lePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="text-right flex-1">
      <button mat-flat-button color="accent" style="padding-left: 5px; padding-right: 5px; margin-bottom: 10px;" (click)="deny()">DENY INFORMATION</button>
      <button mat-flat-button color="accent" style="margin-left: 20px; padding-left: 5px; padding-right: 5px;" (click)="submit()">CONFIRM INFORMATION</button>
    </div>
  </div>
</form>
